import React from 'react';
import styled from 'styled-components';
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaPython,FaMicrochip } from "react-icons/fa";
import {SiMongodb, SiMysql, SiPhp, SiCodeigniter, SiQt, SiDotnet, SiSass } from "react-icons/si";

const Container = styled.div`
  width: 100%;
  padding: 60px 20px;
  background-color: #111;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  margin-bottom: 40px;
  color: #f5f5f5;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  justify-items: center;
  align-items: center;
`;
const SkillCard = styled.div`
  width: 140px;
  height: 140px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #1e1e1e;
  border-radius: 15px;
  padding: 15px;

  transition: transform 0.3s ease, background 0.3s ease;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.05);

  &:hover {
    transform: translateY(-5px);
    background: #222;
  }
`;

const SkillIconImg = styled.img`
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 10px;
`;

const SkillIconReact = styled.div`
  font-size: 58px;
  color: #f5f5f5;
  margin-bottom: 10px;
`;


const SkillIcon = styled.img`
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 10px;
`;
const IconWrapper = styled.div`
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;

const SkillName = styled.span`
  font-size: 0.95rem;
  color: #f5f5f5;
`;

const skills = [
  /*{ name: 'HTML', img: h },
  { name: 'CSS', img: c },
  { name: 'JavaScript', img: j },
  { name: 'Material UI', img: m },
  { name: 'PHPMyAdmin', img: p },
  { name: 'React.js', img: r },
  { name: 'SCSS', img: s },
  { name: 'SQL', img: sq },
  { name: 'Node.js', img: k },
  { name: 'CodeIgniter', img: q },
  { name: 'C Programming', img: o },
  { name: 'MongoDB', img: e },
  { name: 'Python', img: i },*/
   { name: "HTML5", icon: <FaHtml5 /> },
  { name: "CSS3", icon: <FaCss3Alt /> },
  { name: "JavaScript", icon: <FaJs /> },
  { name: "React", icon: <FaReact /> },
  { name: "Node.js", icon: <FaNodeJs /> },
  { name: "MongoDB", icon: <SiMongodb /> },
  { name: "MySQL", icon: <SiMysql /> },
  { name: "CodeIgniter", icon: <SiCodeigniter /> },
  { name: "SCSS", icon: <SiSass /> },
  { name: "Python", icon: <FaPython /> },

  // New ones (NO image needed)
  { name: 'Embedded Systems', icon: <FaMicrochip /> },
  { name: 'C# / .NET', icon: <SiDotnet /> },
  { name: 'Qt', icon: <SiQt /> },
  
];

const Skills = () => {
  return (
    <Container id="skills">
      <Title>My Skills</Title>
      <Grid>
        {skills.map((skill, index) => (
          <SkillCard key={index}>
            <IconWrapper>
  {skill.img ? (
    <SkillIconImg src={skill.img} alt={skill.name} />
  ) : (
    <SkillIconReact>{skill.icon}</SkillIconReact>
  )}
</IconWrapper>

            <SkillName>{skill.name}</SkillName>
          </SkillCard>
        ))}
      </Grid>
    </Container>
  );
};

export default Skills;
